





































import Vue from "vue";
import { formatAsMoney } from "../../../../helpers/format";
import Invoice from "../../../../types/invoices/Invoice";
import { PropType } from "vue/types/options";

export default Vue.extend({
  name: "edit-invoice-form-final",
  props: {
    invoiceData: {
      type: Object as PropType<Invoice>,
      required: true,
    },
  },
  computed: {
    getInvoiceData() {
      return this.invoiceData;
    },
  },
  data() {
    return {};
  },
  methods: {
    moneyFormatter: function (value: number) {
      return formatAsMoney(value, "EUR", this.$i18n.i18next.language);
    },
  },
});
